import { Cloud, CloudOff, Loader2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface OfflineIndicatorProps {
  isOnline: boolean;
  isSyncing: boolean;
  queueLength: number;
  className?: string;
}

export const OfflineIndicator = ({ isOnline, isSyncing, queueLength, className }: OfflineIndicatorProps) => {
  if (isOnline && queueLength === 0 && !isSyncing) {
    return null; // Don't show anything when online and synced
  }

  return (
    <Badge
      variant={isOnline ? "secondary" : "destructive"}
      className={cn("flex items-center gap-2 px-3 py-1", className)}
    >
      {isSyncing ? (
        <>
          <Loader2 className="h-3 w-3 animate-spin" />
          <span className="text-xs">Synchronisiere...</span>
        </>
      ) : isOnline && queueLength > 0 ? (
        <>
          <Cloud className="h-3 w-3" />
          <span className="text-xs">{queueLength} ausstehend</span>
        </>
      ) : !isOnline ? (
        <>
          <CloudOff className="h-3 w-3" />
          <span className="text-xs">
            Offline {queueLength > 0 && `(${queueLength})`}
          </span>
        </>
      ) : null}
    </Badge>
  );
};
